const FEATURE_ITEMS = [
  {
    icon: 'ri-calendar-check-line',
    title: '每日更新不鸽',
    desc: '365天全年无休，每天定时推送最新黑料，早上中午晚上三档更新雷打不动，让你永远有瓜可吃。',
  },
  {
    icon: 'ri-global-line',
    title: '全网聚合吃瓜',
    desc: '覆盖娱乐圈、网红圈、综艺圈、社会热点等全领域，一站汇聚全网热门黑料，不用到处切换平台。',
  },
  {
    icon: 'ri-folders-line',
    title: '分类清晰好找',
    desc: '七大主题频道 + 九大话题标签 + 排行榜，多种方式快速定位你感兴趣的内容类型，吃瓜效率拉满。',
  },
  {
    icon: 'ri-award-line',
    title: '吃瓜排行榜单',
    desc: '实时更新的黑料热度排行榜，一眼看出今天什么瓜最火。历史榜单可回溯，不错过任何经典名场面。',
  },
  {
    icon: 'ri-shield-check-line',
    title: '安全放心吃瓜',
    desc: '严格保护投稿人隐私，匿名爆料全程加密。所有内容标注可信度等级，拒绝谣言，做负责任的吃瓜平台。',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-4xl text-foreground-950 mb-3">
            为什么选择我们
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            五大核心优势，打造全网最靠谱的吃瓜体验
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4 md:gap-5">
          {FEATURE_ITEMS.map((item) => (
            <div
              key={item.title}
              className="flex flex-col items-center text-center p-5 md:p-6 rounded-lg bg-background-100 border border-background-200/60"
            >
              <div className="w-14 h-14 md:w-16 md:h-16 flex items-center justify-center rounded-full bg-accent-100 text-accent-600 mb-4">
                <i className={`${item.icon} text-2xl md:text-3xl`}></i>
              </div>
              <h3 className="font-semibold text-sm md:text-base text-foreground-800 mb-2">
                {item.title}
              </h3>
              <p className="text-xs md:text-sm text-foreground-600 leading-relaxed">
                {item.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}